export const verification = {
  en: {
    "verification.buttons.start": "Start",
    "verification.buttons.next": "Next",
    "verification.buttons.back": "Back",
    "verification.buttons.submit": "Submit",
    "verification.buttons.contact": "Contact us",

    "verification.header.title": "KYC Verification Steps",
    "verification.header.personal": "Personal Information",
    "verification.header.id": "ID Verification",
    "verification.header.review": "Review",
    "verification.header.done": "Done",
    "verification.home.header":
      "After passing the ID verification, you will be entitled to the below privileges",
    "verification.home.privileges": [
      "Increase 24-hour withdrawal limit to 200 BTC",
      "Fiat-Crypto Purchases",
    ],
    "verification.home.description": [
      "You can verify with ID Card, Driving Licence and Passport.",
      "Please make sure that the info provided is identical to your ID info, and these informations cannot be altered once the ID verification is approved.",
      "We only collect your personal information for the sole purpose of identity verification. We are committed to ensuring the highest level of security for your information, utilizing advanced encryption and protection protocols to safeguard your privacy.",
      "Currently, FalconX does not support ID Verification for users in China, America, U.S. Minor Outlying Islands, Hong Kong, China, Canada.",
      "The audit results will be sent to your Email in 1~3 working days. Please check your mailbox.",
    ],

    "verification.step": "Step",

    "verification.step1.header": "Verify Your identity",
    "verification.step1.description":
      "Fill in the required fields with your personal information",
    "verification.step1.firstName": "First Name",
    "verification.step1.lastName": "Last Name",
    "verification.step1.country": "Your Country",
    "verification.step1.country_placeholder": "Ukraine",
    "verification.step1.country_select_placeholder": "Select country",
    "verification.step1.dob": "Date of Birth",

    "verification.step2.header": "ID Verification Title",
    "verification.step2.description":
      "Please provide a photo of a valid identification document (ID card, passport or driver's license)",
    "verification.step2.choose-title":
      "Choose the document you'd like to provide (only one is required)",
    "verification.step2.id-title": "ID Card Title",
    "verification.step2.id-description": "Use ID Card for KYC",
    "verification.step2.license-title": "Driver's License",
    "verification.step2.license-description": "Use Driver’s license for KYC",
    "verification.step2.passport-title": "Passport",
    "verification.step2.passport-description": "Use Passport for KYC",
    "verification.step2.upload-title": "Upload your",
    "verification.step2.upload-description.part1": "Drop files here or click",
    "verification.step2.upload-description.browse": "browse",
    "verification.step2.upload-description.part2": "through your machine",
    "verification.step2.upload-photo": "Upload photo",
    "verification.step2.take-photo": "Take photo",
    "verification.step2.document-front-description":
      "Upload the main document photo.",
    "verification.step2.selfie-title": "Upload selfie",
    "verification.step2.selfie-description": "Upload a clear selfie photo.",
    "verification.step2.back-title": "Upload back side of document",
    "verification.step2.back-description":
      "Upload the back side if your document has one.",
    "verification.error.step2.selfie-required": "Selfie is required.",
    "verification.error.step2.file-type":
      "Only JPEG, PNG or WebP files are allowed.",
    "verification.error.step2.file-size": "Maximum file size is 2MB.",
    "verification.step2.change-photo": "Change photo",
    "verification.step2.remove-photo": "Remove photo",
    "verification.error.step2.back-required":
      "Please upload the back side of the document.",

    "verification.error.step3.email": "Email is required",
    "verification.step3.header": "Review your information",
    "verification.step3.description":
      "Please take a moment to double-check your details for accuracy before submitting",
    "verification.step3.title": "Submitted information",
    "verification.step3.edit-title": "Edit",
    "verification.step3.firstName": "Name",
    "verification.step3.lastName": "Last Name",
    "verification.step3.country": "Nationality",
    "verification.step3.dob": "Date of Birth",
    "verification.step3.email": "Email address",
    "verification.step3.user-id": "ID number",

    "verification.step4.header": "Your request is currently under review",
    "verification.step4.description": "Please wait for confirmation",
    "verification.step4.info":
      "Your submitted documents are currently under review to verify your identity. This process may take some time depending on the volume of requests. We will notify you once your verification is complete. Thank you for your patience as we work to ensure the security of your account.",

    "verification.error.step1.firstName": "First name is required",
    "verification.error.step1.lastName": "Last name is required",
    "verification.error.step1.country": "Country is required",
    "verification.error.step1.dateBirth": "Date of birth is required",
    "verification.error.step2.upload-required":
      "Please upload a document before proceeding",
    "verification.error.step3.email.en": "Email is required",
  },

  ru: {
    "verification.buttons.start": "Начать",
    "verification.buttons.next": "Далее",
    "verification.buttons.back": "Назад",
    "verification.buttons.submit": "Отправить",
    "verification.buttons.contact": "Свяжитесь с нами",

    "verification.header.title": "Шаги KYC верификации",
    "verification.header.personal": "Личная информация",
    "verification.header.id": "Верификация личности",
    "verification.header.review": "Проверка",
    "verification.header.done": "Завершено",
    "verification.home.header":
      "После прохождения верификации личности вы получите следующие привилегии",
    "verification.home.privileges": [
      "Увеличение суточного лимита на вывод до 200 BTC",
      "Покупки Fiat-Crypto",
    ],
    "verification.home.description": [
      "Вы можете пройти верификацию с помощью ID-карты, водительского удостоверения или паспорта.",
      "Пожалуйста, убедитесь, что предоставленная информация совпадает с данными вашего удостоверения личности, и эти данные не могут быть изменены после утверждения верификации.",
      "Мы собираем вашу личную информацию исключительно для целей проверки личности. Мы обязуемся обеспечивать высокий уровень безопасности вашей информации, используя передовые протоколы шифрования и защиты для сохранения вашей конфиденциальности.",
      "В настоящее время FalconX не поддерживает верификацию личности для пользователей из Китая, Америки, Малых обитаемых островов США, Гонконга, Китая, Канады.",
      "Результаты проверки будут отправлены на вашу электронную почту в течение 1–3 рабочих дней. Пожалуйста, проверьте ваш почтовый ящик.",
    ],

    "verification.step": "Шаг",

    "verification.step1.header": "Подтвердите свою личность",
    "verification.step1.description":
      "Заполните обязательные поля вашей личной информацией",
    "verification.step1.firstName": "Имя",
    "verification.step1.lastName": "Фамилия",
    "verification.step1.country": "Ваша страна",
    "verification.step1.country_placeholder": "Украина",
    "verification.step1.country_select_placeholder": "Выберите страну",
    "verification.step1.dob": "Дата рождения",

    "verification.step2.header": "Подтверждение личности",
    "verification.step2.description":
      "Пожалуйста, предоставьте фотографию действительного документа, удостоверяющего личность (ID-карта, паспорт или водительское удостоверение).",
    "verification.step2.choose-title":
      "Выберите документ, который вы хотите предоставить (достаточно одного)",
    "verification.step2.id-title": "ID-карта",
    "verification.step2.id-description":
      "Используйте ID-карту для подтверждения",
    "verification.step2.license-title": "Водительское удостоверение",
    "verification.step2.license-description":
      "Используйте водительское удостоверение для подтверждения",
    "verification.step2.passport-title": "Паспорт",
    "verification.step2.passport-description":
      "Используйте паспорт для подтверждения",
    "verification.step2.upload-title": "Загрузите",
    "verification.step2.upload-description.part1":
      "Перетащите файлы сюда или нажмите",
    "verification.step2.upload-description.browse": "выбрать",
    "verification.step2.upload-description.part2": "на устройстве",
    "verification.step2.upload-photo": "Загрузить фото",
    "verification.step2.take-photo": "Сделать фото",
    "verification.step2.document-front-description":
      "Загрузите основное фото документа.",
    "verification.step2.selfie-title": "Загрузите селфи",
    "verification.step2.selfie-description": "Загрузите чёткое селфи-фото.",
    "verification.step2.back-title": "Загрузите обратную сторону документа",
    "verification.step2.back-description":
      "Загрузите обратную сторону, если она есть у документа.",
    "verification.error.step2.selfie-required": "Необходимо загрузить селфи.",
    "verification.error.step2.file-type":
      "Разрешены только файлы JPEG, PNG или WebP.",
    "verification.error.step2.file-size": "Максимальный размер файла — 2MB.",
    "verification.step2.change-photo": "Изменить фото",
    "verification.step2.remove-photo": "Удалить фото",
    "verification.error.step2.back-required":
      "Пожалуйста, загрузите обратную сторону документа.",

    "verification.error.step3.email": "Электронная почта обязательна",
    "verification.step3.header": "Проверьте ваши данные",
    "verification.step3.description":
      "Пожалуйста, уделите немного времени, чтобы проверить точность ваших данных перед отправкой",
    "verification.step3.title": "Отправленная информация",
    "verification.step3.edit-title": "Редактировать",
    "verification.step3.firstName": "Имя",
    "verification.step3.lastName": "Фамилия",
    "verification.step3.country": "Гражданство",
    "verification.step3.dob": "Дата рождения",
    "verification.step3.email": "Электронная почта",
    "verification.step3.user-id": "Идентификационный номер",

    "verification.step4.header": "Ваш запрос находится на проверке",
    "verification.step4.description": "Пожалуйста, дождитесь подтверждения",
    "verification.step4.info":
      "Отправленные вами документы сейчас проходят проверку для подтверждения вашей личности. Этот процесс может занять некоторое время в зависимости от количества запросов. Мы уведомим вас, как только ваша верификация будет завершена. Спасибо за ваше терпение — мы работаем над обеспечением безопасности вашего аккаунта.",

    "verification.error.step1.firstName": "Имя обязательно для заполнения",
    "verification.error.step1.lastName": "Фамилия обязательна для заполнения",
    "verification.error.step1.country": "Страна обязательна для заполнения",
    "verification.error.step1.dateBirth":
      "Дата рождения обязательна для заполнения",
    "verification.error.step2.upload-required":
      "Пожалуйста, загрузите документ перед продолжением",
    "verification.error.step3.email.ru": "Электронная почта обязательна",
  },

  es: {
    "verification.buttons.start": "Comenzar",
    "verification.buttons.next": "Siguiente",
    "verification.buttons.back": "Atrás",
    "verification.buttons.submit": "Enviar",
    "verification.buttons.contact": "Contáctenos",

    "verification.header.title": "Pasos de verificación KYC",
    "verification.header.personal": "Información personal",
    "verification.header.id": "Verificación de identidad",
    "verification.header.review": "Revisión",
    "verification.header.done": "Completado",
    "verification.home.header":
      "Después de pasar la verificación de identidad, tendrá derecho a los siguientes privilegios",
    "verification.home.privileges": [
      "Aumentar el límite de retiro de 24 horas a 200 BTC",
      "Compras Fiat-Crypto",
    ],
    "verification.home.description": [
      "Puede verificar con tarjeta de identificación, licencia de conducir y pasaporte.",
      "Por favor, asegúrese de que la información proporcionada sea idéntica a la de su documento de identidad, y esta información no se puede modificar una vez aprobada la verificación.",
      "Solo recopilamos su información personal con el único propósito de la verificación de identidad. Estamos comprometidos a garantizar el más alto nivel de seguridad para su información, utilizando protocolos avanzados de cifrado y protección para salvaguardar su privacidad.",
      "Actualmente, FalconX no admite la verificación de identidad para usuarios en China, América, Islas Menores Alejadas de EE. UU., Hong Kong, China, Canadá.",
      "Los resultados de la auditoría se enviarán a su correo electrónico en 1~3 días hábiles. Por favor, revise su buzón.",
    ],

    "verification.step": "Paso",

    "verification.step1.header": "Verifica tu identidad",
    "verification.step1.description":
      "Rellene los campos obligatorios con su información personal",
    "verification.step1.firstName": "Nombre",
    "verification.step1.lastName": "Apellido",
    "verification.step1.country": "Tu país",
    "verification.step1.country_placeholder": "Ucrania",
    "verification.step1.country_select_placeholder": "Selecciona país",
    "verification.step1.dob": "Fecha de nacimiento",

    "verification.step2.header": "Verificación de identidad",
    "verification.step2.description":
      "Por favor, proporciona una foto de un documento de identificación válido (DNI, pasaporte o licencia de conducir).",
    "verification.step2.choose-title":
      "Elige el documento que deseas proporcionar (solo se requiere uno)",
    "verification.step2.id-title": "Documento de identidad",
    "verification.step2.id-description":
      "Usa tu documento de identidad para la verificación",
    "verification.step2.license-title": "Licencia de conducir",
    "verification.step2.license-description":
      "Usa tu licencia de conducir para la verificación",
    "verification.step2.passport-title": "Pasaporte",
    "verification.step2.passport-description":
      "Usa tu pasaporte para la verificación",
    "verification.step2.upload-title": "Sube tu",
    "verification.step2.upload-description.part1":
      "Arrastra archivos aquí o haz clic para",
    "verification.step2.upload-description.browse": "buscar",
    "verification.step2.upload-description.part2": "en tu dispositivo",
    "verification.step2.upload-photo": "Subir foto",
    "verification.step2.take-photo": "Tomar foto",
    "verification.step2.document-front-description":
      "Sube la foto principal del documento.",
    "verification.step2.selfie-title": "Sube una selfie",
    "verification.step2.selfie-description": "Sube una foto selfie clara.",
    "verification.step2.back-title": "Sube la parte trasera del documento",
    "verification.step2.back-description":
      "Sube la parte trasera si tu documento la tiene.",
    "verification.error.step2.selfie-required": "La selfie es obligatoria.",
    "verification.error.step2.file-type":
      "Solo se permiten archivos JPEG, PNG o WebP.",
    "verification.error.step2.file-size":
      "El tamaño máximo del archivo es 2MB.",
    "verification.step2.change-photo": "Cambiar foto",
    "verification.step2.remove-photo": "Eliminar foto",
    "verification.error.step2.back-required":
      "Por favor, cargue la parte posterior del documento.",

    "verification.error.step3.email": "El correo electrónico es obligatorio",
    "verification.step3.header": "Revisa tu información",
    "verification.step3.description":
      "Por favor, tómate un momento para verificar que tus datos sean correctos antes de enviar",
    "verification.step3.title": "Información enviada",
    "verification.step3.edit-title": "Editar",
    "verification.step3.firstName": "Nombre",
    "verification.step3.lastName": "Apellido",
    "verification.step3.country": "Nacionalidad",
    "verification.step3.dob": "Fecha de nacimiento",
    "verification.step3.email": "Correo electrónico",
    "verification.step3.user-id": "Número de identificación",

    "verification.step4.header": "Tu solicitud está en revisión",
    "verification.step4.description": "Por favor, espera la confirmación",
    "verification.step4.info":
      "Los documentos que enviaste están siendo revisados para verificar tu identidad. Este proceso puede tardar algún tiempo dependiendo del volumen de solicitudes. Te notificaremos cuando tu verificación haya sido completada. Gracias por tu paciencia mientras trabajamos para garantizar la seguridad de tu cuenta.",

    "verification.error.step1.firstName": "El nombre es obligatorio",
    "verification.error.step1.lastName": "El apellido es obligatorio",
    "verification.error.step1.country": "El país es obligatorio",
    "verification.error.step1.dateBirth":
      "La fecha de nacimiento es obligatoria",
    "verification.error.step2.upload-required":
      "Por favor, sube un documento antes de continuar",
    "verification.error.step3.email.es": "El correo electrónico es obligatorio",
  },

  ua: {
    "verification.buttons.start": "Почати",
    "verification.buttons.next": "Далі",
    "verification.buttons.back": "Назад",
    "verification.buttons.submit": "Відправити",
    "verification.buttons.contact": "Зв'яжіться з нами",

    "verification.header.title": "Кроки KYC верифікації",
    "verification.header.personal": "Особиста інформація",
    "verification.header.id": "Верифікація особи",
    "verification.header.review": "Перевірка",
    "verification.header.done": "Завершено",
    "verification.home.header":
      "Після проходження верифікації особи ви отримаєте наступні привілеї",
    "verification.home.privileges": [
      "Збільшення добового ліміту на зняття до 200 BTC",
      "Покупки Fiat-Crypto",
    ],
    "verification.home.description": [
      "Ви можете пройти верифікацію за допомогою ID-карти, водійського посвідчення або паспорта.",
      "Будь ласка, переконайтеся, що надана інформація ідентична вашій інформації в документі, і ці дані не можна змінити після затвердження верифікації.",
      "Ми збираємо вашу особисту інформацію виключно з метою перевірки особи. Ми прагнемо забезпечити найвищий рівень безпеки ваших даних, використовуючи сучасні протоколи шифрування та захисту для збереження вашої конфіденційності.",
      "На даний момент FalconX не підтримує верифікацію особи для користувачів з Китаю, Америки, Малих віддалених островів США, Гонконгу, Китаю, Канади.",
      "Результати перевірки будуть надіслані на вашу електронну пошту протягом 1–3 робочих днів. Будь ласка, перевірте вашу поштову скриньку.",
    ],

    "verification.step": "Крок",

    "verification.step1.header": "Підтвердьте свою особу",
    "verification.step1.description":
      "Заповніть обов'язкові поля вашою особистою інформацією",
    "verification.step1.firstName": "Ім’я",
    "verification.step1.lastName": "Прізвище",
    "verification.step1.country": "Ваша країна",
    "verification.step1.country_placeholder": "Україна",
    "verification.step1.country_select_placeholder": "Оберіть країну",
    "verification.step1.dob": "Дата народження",

    "verification.step2.header": "Підтвердження особи",
    "verification.step2.description":
      "Будь ласка, надайте фото дійсного документа, що посвідчує особу (ID-картка, паспорт або водійське посвідчення).",
    "verification.step2.choose-title":
      "Оберіть документ, який хочете надати (достатньо одного)",
    "verification.step2.id-title": "ID-картка",
    "verification.step2.id-description":
      "Використайте ID-картку для підтвердження",
    "verification.step2.license-title": "Водійське посвідчення",
    "verification.step2.license-description":
      "Використайте водійське посвідчення для підтвердження",
    "verification.step2.passport-title": "Паспорт",
    "verification.step2.passport-description":
      "Використайте паспорт для підтвердження",
    "verification.step2.upload-title": "Завантажте",
    "verification.step2.upload-description.part1":
      "Перетягніть файли сюди або натисніть",
    "verification.step2.upload-description.browse": "обрати",
    "verification.step2.upload-description.part2": "на пристрої",
    "verification.step2.upload-photo": "Завантажити фото",
    "verification.step2.take-photo": "Зробити фото",
    "verification.step2.document-front-description":
      "Завантажте основне фото документа.",
    "verification.step2.selfie-title": "Завантажте селфі",
    "verification.step2.selfie-description": "Завантажте чітке селфі-фото.",
    "verification.step2.back-title": "Завантажте зворотну сторону документа",
    "verification.step2.back-description":
      "Завантажте зворотну сторону, якщо документ її має.",
    "verification.error.step2.selfie-required": "Потрібно завантажити селфі.",
    "verification.error.step2.file-type":
      "Дозволені лише файли JPEG, PNG або WebP.",
    "verification.error.step2.file-size": "Максимальний розмір файлу — 2MB.",
    "verification.step2.change-photo": "Змінити фото",
    "verification.step2.remove-photo": "Видалити фото",
    "verification.error.step2.back-required":
      "Будь ласка, завантажте зворотну сторону документа.",

    "verification.error.step3.email": "Електронна пошта є обов’язковою",
    "verification.step3.header": "Перевірте вашу інформацію",
    "verification.step3.description":
      "Будь ласка, приділіть трохи часу, щоб перевірити точність ваших даних перед відправкою",
    "verification.step3.title": "Надіслана інформація",
    "verification.step3.edit-title": "Редагувати",
    "verification.step3.firstName": "Ім’я",
    "verification.step3.lastName": "Прізвище",
    "verification.step3.country": "Громадянство",
    "verification.step3.dob": "Дата народження",
    "verification.step3.email": "Електронна адреса",
    "verification.step3.user-id": "Ідентифікаційний номер",

    "verification.step4.header": "Ваш запит перебуває на перевірці",
    "verification.step4.description": "Будь ласка, дочекайтеся підтвердження",
    "verification.step4.info":
      "Надіслані вами документи зараз проходять перевірку для підтвердження вашої особи. Цей процес може зайняти певний час залежно від кількості запитів. Ми повідомимо вас, щойно ваша верифікація буде завершена. Дякуємо за терпіння — ми працюємо над забезпеченням безпеки вашого акаунта.",

    "verification.error.step1.firstName": "Ім'я є обов'язковим",
    "verification.error.step1.lastName": "Прізвище є обов'язковим",
    "verification.error.step1.country": "Країна є обов'язковою",
    "verification.error.step1.dateBirth": "Дата народження є обов'язковою",
    "verification.error.step2.upload-required":
      "Будь ласка, завантажте документ перед продовженням",
    "verification.error.step2.upload-required.uk":
      "Будь ласка, завантажте документ перед продовженням",
    "verification.error.step3.email.uk": "Електронна пошта є обов’язковою",
  },
};

export default verification;
